module.exports = {
    premiumFrequencyOptions:["-None-","One Time", "Monthly", "Quarterly", "Annual"],
    policyStatusOptions: ["-None-", "Application", "Applied and In Process", "Amendment Requested", "Application Approved with Rating", "Application Approved without Rating", "Policy Issued and Active", "Policy Issued but Inactive", "Policy Taken by Client / Closed", "Policy Not taken by Client", "Application Postponed by Client", "Application Postponed by Client", "Application Declined", "Expired / Inactive", "Expired / Inactive"],
    statusOption: [
        "-None-",
          "One Time",
          "Monthly",
          "Quaterly",
          "Annualy"
      ],      
      insuranceleadSourceOption:[
        "-None-",
          "-None-",
          "Radio",
          "Trade Show",
          "Vendor Partner Seminar",
          "Referral",
          "Internal Seminar",
          "Google",
          "Social Media",
          "Cold Call",
          "Email Campaign",
          "Website",
          "Facebook",
          "Twitter",
          "Canadian LIC Website",
          "Harpreet Puri Website",
          "Linked In",
          "SVIC Website (Super Visa)",
          "Walk Ins",
          "Old Database",
          "Google AdWords",
        ],
        policyStatusOption: [
        "-None-",
          "Application",
          "Applied and in Process",
          "Amendment Requested",
          "Application Approved with Rating",
          "Application Approved without Rating",
          "Policy Issue and active",
          "Policy Taken By Client / Closed",
          "Policy Not Taken By Client",
          "Application Postponed By CLient",
          "Application Canceled By CLient",
          "Application Declined",
          "Expired / Inactive",
          "Policy Issued Waiting Future Activation"
        ],
        advisorCodeOfConductComplainceOption: [
        "-None-",
          "Maintained active licences and the required errors and omissions insurance",
          "Placed the Customers Best Interests First",
          "Held Out Representation Appropriately",
          "Made Needs-Based Recommendations",
          "Made Clear and Accurate Representations",
          "Provided Segregated Fund Point of Sale Disclosures",
          "Provided Full Disclosure",
          "Recommended Replacements Only When it is Appropriate to Do So",
          "Used Only Approved Sales Illustrations",
          "Obeyed the Rules for Commission Splitting",
          "Protected Privacy & Confidentiality",
          "Respected Copyrights",
          "Obeyed the Rules for Referrals and Referral Fees",
          "Delivered All Documents Immediately",
          "Handled and Reported Complaints Appropriately",
          "Followed Guidelines relevant to Anti-Money Laundering",
          `Complied with CRTCs Unsolicited Telecommunications Rules, including National Do Not Call List “N- DNCL”`,
          "Kept Accurate and Substantial Books & Records",
          "Notified Canadian LIC Administration of any discrepancies",
          "Recommended Leveraging Only When it is Appropriate to Do So",
          "Avoided Conflicts of Interest",
          "Maintained a Complaint Log",
        ],
        policyTypeOption: [
        "-None-",
          "Term Life",
          "Term Universal Life",
          "Permanenent Universal Life",
          "Whole Life",
          "Participating Whole Life",
          "Non Medical",
          "Travel",
          "Super Visa",
          "Health and Dental",
          "Critical Illness",
          "Disability Accidental",
          "Disability Illness",
          "Visitors",
          "Business Insurnace",
          "Mutual Funds",
          "TFSA",
          "Combination Or Hybrid Insurance",
          "Seg Funds",
          "Annuities",
          "RRSP",
          "RESP",
          "GIC ",      
          "Saving Account",
          "Pension Plan",
          "RIF",
          "GIA",
          "Permanent / T100",
          "Accidental Benefits",
          "Rent Insurance",
          "Mortgage Protection",
          "Credit Protection",
          "Group Life",
          "Group Disability",
          "Group Life",
          "Group Disability",
          "Group Accidental Benefits",
          "Group Health and Dental",
          "Group Travel",
          "Group Eye Care",
          "Group Critical Illness",
          "Group Flexible Plan",
          "International Student"
      
        ],      
      dealOption: [
        "-None-",
          "Chapman",
          "Morlong Associates",
          "Commercial Press",
          "Chanay",
          "Trigya Innovations",
          "Chemel",
          "Feltz Priting Service",
          "Printing Dimensions",
          "test test",
          "Truhlar and Truhlar Attys",
          "King",
          "Mr. Christopher Maclead (Sample)",
          "Benton",
      
        ],
       advisorProbhitedOption:[
        "-None-",
          "Complied with Prohibition of certain methods of Payments",
          "Complied with Prohibition of Fronting",
          "Complied with Rebating and Inducements",
          "Complied with Prohibition of Viatical Agreements/Life Settlements/Stranger Owned or Investor Owned Life Insurance",
          "Complied wth Prohibition of Tied Selling",
          "Complied with Prohibition of Selling insurance or providing advice without having a valid insurance license",
          "Complied with Prohibition of Engaging in Criminal Behavior While Performing the Duties of an Agent",
          "Complied with Prohibition of Selling insurance or providing advice without having a valid errors and omissions insurance",
          "Complied with Prohibition of Forgery and Alteration of Documents",
          "Complied with Prohibition of Exercise of Discretionary Authority",
          "Complied with Prohibition of Twisting",
          "Complied with Prohibition of Churning",
          "Complied with Prohibition of Improper Use of Sale",
      
      
        ],
        lifeInsuranceOption: [
          "-None-",
          "Term Life",
          "Universal Life",
          "Permanent Universal Life",
          "Whole Life",
          "Participating Whole Life",
          "Non Medical",
          "Permanent / T100",
        ],
        lifeBenefitsOption:[
          "-None-",
          "Critical Illness Disability - Accidental",
          "Disability - Accidental",
          "Disability - Illness",
          "Hospital Expenses",
          "Accidental Benefits",
          "Option 2",
          "Critical Illness",
        ],
        relationOptionsSubform:[
          "-None-",
          "self",
          "Spouse",
          "Son",
          "Daughter-in-law",
          "Daughter",
          "Son-In-Law",
          "Father-in-Law",
          "Father",
          "Mother-in-Law",
          "Mother",
         "Sister",
         "Brother"
        ],
        frequencyOptions:[
          "-None-",
          "Monthly",
          "Lump Sump",
          "One Time",
          "Annual"
        ],
        clientFirstPolicyOptions: ["-None-", "Yes", "No"],
        genderOptions: ["-None-", "Male", "Female"],
        sendToPolicyStartDateEmailTrackOptions: ["-None-", "Success", "Failed"],
        claimOutcomeOption: ["-None-", "Approved", "Rejected"],
        advisorBonusLevelOptions: ["-None-", "1", "2", "3", "4", "5", "6", "7", "8"],
        layoutOption:["-None-", "Life Policies", "  Travel And SuperVisa"],
         approvalRatingOptions:["-None-", "Approved With Rating", "Approved Without Rating"],
        applicationMedicalRequirementOptions:["-None-", "Required", "Not Required"],
        typeOptions:["-None-", "HISA", "DIF", "GIF", "Seg"],

}